export default "__VITE_ASSET__KvySQEY9__"